import {BinIcon} from "../../../components/icon/Icon";
import {Button} from "react-bootstrap";
import { useCallback, useContext, useEffect, useState } from "react";
import {resendCodeAction} from "../loginActions";
import {connect} from "react-redux";
import { useLangContext } from "../../../providers/LangProvider/LangProviderContext.js";

const COOLDOWN_LENGTH = 45;

const formatSeconds = (secondsNumber) => secondsNumber < 10 ? `0${secondsNumber}` : secondsNumber;

export const ResendCodeButton = (props) => {
    const {
        className,
        email,
        requestType,
        resendCode,
        as,
        resendLabel,
        resendOnTimerLabel,
        resendSuccessLabel,
        ...buttonProps
    } = props;
    const {getLangPath} = useLangContext();
    const [cooldown, setCooldown] = useState(COOLDOWN_LENGTH);
    const [showSuccessResendLinkMessage, setShowSuccessResendLinkMessage] = useState(false);

    useEffect(() => {
        if (cooldown > 0) {
            const timer = setTimeout(() => {
                setCooldown(cooldown - 1);
            }, 1000);
            return () => {
                clearTimeout(timer);
            }
        }
    }, [cooldown]);

    useEffect(() => {
        if (showSuccessResendLinkMessage) {
            const timer = setTimeout(() => {
                setCooldown(COOLDOWN_LENGTH);
                setShowSuccessResendLinkMessage(false);
            }, 3000);
            return () => {
                clearTimeout(timer);
            }
        }
    }, [showSuccessResendLinkMessage]);

    const resendCodeHandler = useCallback((e) => {
        e.preventDefault();
        resendCode({ requestType, email });
        setShowSuccessResendLinkMessage(true);
    }, [email, requestType, resendCode]);

    return (
            <Button size={'lg'}
                    variant={'info'}
                    className={className}
                    onClick={resendCodeHandler}
                    disabled={cooldown > 0 || showSuccessResendLinkMessage}
                    {...buttonProps}
            >
                {
                    showSuccessResendLinkMessage
                            ? (
                                    <div className="d-flex justify-content-center">
                                        <BinIcon name="IcCheckMarkCircleGreen" className="me-2"/>
                                        <span>{getLangPath(resendSuccessLabel || 'email_confirmation.send_link')}</span>
                                    </div>
                            ) : (
                                    <div>
                                        <span>
                                            {
                                                getLangPath(cooldown > 0
                                                    ? resendOnTimerLabel || 'email_confirmation.resend_link'
                                                    : resendLabel || 'email_confirmation.request_link')
                                            }
                                        </span>
                                        <span>{cooldown > 0 ? ` 00:${formatSeconds(cooldown)}` : ''}</span>
                                    </div>
                            )
                }
            </Button>
    )
}

const mapDispatchToProps = (dispatch) => ({
    resendCode: (payload) => dispatch(resendCodeAction(payload)),
});

export default connect(null, mapDispatchToProps)(ResendCodeButton);